import React from "react";
import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { NAV_LINKS, FOOTER } from "../mock/mock";
import Logo from "./Logo";

const LEGAL_LINKS = [
  { label: "Mentions légales", to: "/mentions-legales" },
  { label: "Politique de confidentialité", to: "/politique-confidentialite" },
  { label: "Politique cookies", to: "/politique-cookies" },
  { label: "CGV", to: "/cgv" },
];

export default function SiteFooter() {
  const openCookies = () =>
    window.dispatchEvent(new Event("l4-open-cookies"));

  return (
    <footer className="bg-[#0a1626] border-t border-white/10 py-14">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <Link to="/">
            <Logo />
          </Link>
          <nav className="flex flex-wrap justify-center gap-6">
            {NAV_LINKS.map((link) => (
              <a
                key={link.to}
                href={`/#${link.to}`}
                className="text-sm text-slate-400 hover:text-[#F5941E] transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="https://www.linkedin.com/company/looking-4"
            target="_blank"
            rel="noopener noreferrer"
            className="flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 text-slate-300 hover:text-[#F5941E] hover:border-[#F5941E]/40 transition-colors"
          >
            <Linkedin size={18} />
          </a>
        </div>

        {/* Legal links */}
        <div className="mt-10 border-t border-white/10 pt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
          {LEGAL_LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="text-xs text-slate-400 hover:text-[#F5941E] transition-colors"
            >
              {l.label}
            </Link>
          ))}
          <button
            onClick={openCookies}
            className="text-xs text-slate-400 hover:text-[#F5941E] transition-colors"
          >
            Gérer mes cookies
          </button>
        </div>

        <div className="mt-6 text-center text-xs text-slate-500">
          {FOOTER.copyright}
        </div>
      </div>
    </footer>
  );
}
